module.exports = __webpack_public_path__ + "img/img_verified_idphoto_a.4e6bd697.png";